import { createRouter, createWebHashHistory } from 'vue-router';
import { createRouterGuards } from './routerGuards';
import { defaultRoutePath } from './constant';
import { outsideLayoutRoutes } from './staticRouter/outsideLayout';
import { staticRouter } from './staticRouter';
export const routes = [
  //后台框架页，勿动
  {
    path: '/layout',
    name: 'layout',
    component: () => import('@/layout/index.vue'),
    redirect: defaultRoutePath
  },
  // Layout之外的路由（登录页、大屏页、门户页等）
  //如果不需要token验证的页面，请到constant.js中添加路由白名单
  ...outsideLayoutRoutes,
  ...staticRouter
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
});

export async function setupRouter(app) {
  // 创建路由守卫
  createRouterGuards(router);
  app.use(router);
  // 路由准备就绪后挂载APP实例
  await router.isReady();
}

//重新加载 router
export function resetRouter() {
  router.getRoutes().forEach(route => {
    const { name } = route;
    if (name && !whiteNameList.some(n => n === name)) {
      router.hasRoute(name) && router.removeRoute(name);
    }
  });
}

export default router;
